'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (feis_id, participantId) {
  return function (dispatch) {
    return dispatch({
      feis_id: feis_id,
      participantId: participantId,

      type: 'SET_CURRENT_STEWARDING_PARTICIPANT'
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/setCurrentParticipant.js
// module id = 247
// module chunks = 0